import React from 'react';

type DayCellProps = {
    day: number;
    dayData: any;
    isClickable: boolean;
    cellStyle: string;
    textColor: string;
    handleSetCurrentDay: (day: number) => void;
    isOpenDays: boolean;
    dayDate: string;
    calendarConfig: any;
    onCalendarCellClick: (event: any) => void;
}

const DayCell = ({
    day,
    dayData,
    isClickable,
    cellStyle,
    textColor,
    handleSetCurrentDay,
    isOpenDays,
    dayDate,
    calendarConfig,
    onCalendarCellClick
}: DayCellProps) => {
    const handleClickOnCell = () => {
        isClickable &&
            handleSetCurrentDay(day);

        if (isOpenDays && onCalendarCellClick) {
            onCalendarCellClick({
                type: 'day',
                date: dayDate
            });
        }
    };

    return (
        <div
            onClick={handleClickOnCell}
            className={`
                    flex flex-col h-28 border-t-2 py-1 px-2 gap-0.5
                    ${cellStyle} ${isClickable ? 'cursor-pointer' : 'cursor-not-allowed'}
                `}
        >
            <p className={`${textColor} text-right text-sm`} style={{fontFamily: 'Roboto'}}>
                {day < 10 ? `0${day}` : day}
            </p>
            {isOpenDays && (calendarConfig.dayCellEventsComponent(dayData, dayDate))}
        </div>
    );
};

export default DayCell;
